// Donation Model
cv.Donor =  Backbone.RESTModel.extend({
  defaults : {
    'display_name' : '',
    'first_name' : '',
    'last_name' : '',
    'anonymous' : '',

    'line1' : '',
    'line2' : '',
    'city' :'',
    'state' : '',
    'zipcode' : '',
    'country' : ''
  },

  saveMap : {
    'display_name' : 'display_name',
    'first_name' : 'first_name',
    'last_name' : 'last_name',
    'anonymous' : 'anonymous',

    'line1' : 'line1',
    'line2' : 'line2',
    'city' :'city',
    'state' : 'state',
    'zipcode' : 'zipcode',
    'country' : 'country',

    'active' : 'active'
  },

  urlRoot: function(){
    return cv.api_path + '/donors';
  },

  initialize: function(){
    console.log('Donor model initialized.');
  }
});
Cocktail.mixin(cv.Donor, cv.mixins.SyncModel);

// Donations Collection
cv.Donors = Backbone.Collection.extend({
  initialize: function(options){
    console.log('Donors collection initialized.');
  },

  url: function() {
    return cv.api_path + "/donors?" + $.param(this.params);
  },

  model: cv.Donor
});
Cocktail.mixin(cv.Donors, cv.mixins.PaginateModel);
